module.exports = __webpack_public_path__ + "img/films-page-bg.db246d3d.jpeg";